<template>
    <div class="product-cart" v-if="!order_created">
        <h3 class="cart-title">{{ $t('general.shopping-cart') }}</h3>
        <v-list-item
            v-for="item in cart"
            :key="item.line_id"
            class="card-item mb-3 d-block"
        >
            <v-card class="card-product d-flex">
                <div class="remove-from-cart" @click="remove_from_cart(item)">&times;</div>
                <v-img
                    :width="124"
                    :height="108"
                    :max-width="124"
                    :max-height="108"
                    cover
                    :src="item.image"
                    class="card-product__img"
                    :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                ></v-img>
                <div class="card-product__data">
                    <v-card-text class="card-product__wrap-text pa-0">
                        <v-card-title class="text-h5 card-product__title text-bold pa-0"
                                      v-if="item.name.length > 60">{{ item.name.slice(0, 60) + '..' }}
                        </v-card-title>
                        <v-card-title class="text-h5 card-product__title text-bold pa-0" v-else>{{
                                item.name
                            }}
                        </v-card-title>
                    </v-card-text>
                    <div class="wrap_select" v-if="!variationGroups(item).length">
                                        <span v-if="item.variation_name.length > 60">{{
                                                item.variation_name.slice(0, 60) + '..'
                                            }}</span>
                        <span v-else>{{ item.variation_name }}</span>
                    </div>
                    <div class="order-block__price" v-if="!variationGroups(item).length"
                         :style="{color: widget.style.color}">&#8364;
                        <span :id="'cart_value_price_' + item.line_id"
                              :style="{color: widget.style.color}">{{ itemPrice(item) }}</span></div>
                    <v-card-actions :class="[widget.style.roundedCorners ? 'card-actions' : 'border-radius-0', {'card-actions--variation': variationGroups(item).length}]"
                    class="pl-0 pb-0">
                        <div class="order-block" :class="{'order-block--variation': variationGroups(item).length}">
                            <div class="cart-variations" v-if="variationGroups(item).length">
                                <div class="cart-variations__item"
                                     v-for="(group, groupIndex) in variationGroups(item)"
                                     :key="group.id">
                                    <select class="card-product__select cart-variations__select"
                                            :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                                            :style="{ 'font-family': widget.style.fontFamily }"
                                            :title="group.title"
                                            :aria-label="group.title"
                                            :value="group.selected"
                                            @change="setCartVariation(item, groupIndex, $event.target.value)">
                                        <option v-if="!group.selected" value="" disabled hidden></option>
                                        <option v-for="option in group.options"
                                                :key="option.value"
                                                :value="option.value">{{ option.value }}
                                        </option>
                                    </select>
                                    <span class="cart-variations__triangle">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div class="qty-block">
                                <div class="qty-block__interface">
                                    <v-btn small @click="btnMinusCart(item)"
                                           :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                                           class="order-block__btnMinus btn-qty">
                                        -
                                    </v-btn>
                                    <v-text-field
                                        solo small flat
                                        :id="'qty_cart_' + item.line_id"
                                        class="qty-block__input order-block__text-field"
                                        :value="item.qty_product"
                                        type="number"
                                        hide-details
                                        min="0"
                                        @input="onQtyInput(item, $event)"
                                        @change="onQtyChange(item, $event)"
                                        :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                                    />
                                    <v-btn small @click="btnPlusCart(item)"
                                           :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                                           class="order-block__btnPlus btn-qty">
                                        +
                                    </v-btn>
                                </div>
                            </div>
                            <div class="order-block__price cart-variations__price" v-if="variationGroups(item).length"
                                 :style="{color: widget.style.color}">&#8364;
                                <span :id="'cart_value_price_' + item.line_id"
                                      :style="{color: widget.style.color}">{{ itemPrice(item) }}</span></div>
                        </div>
                    </v-card-actions>
                </div>
            </v-card>
        </v-list-item>
        <div class="total-price" v-if="deliveryCost">
            Delivery: <span class="total-price__price" :style="{color: widget.style.color}">€ {{ deliveryCost.toFixed(2) }}</span>
        </div>
        <div class="total-price" v-if="deliveryCost">
            {{ $t('general.total') }}: <span class="total-price__price" :style="{color: widget.style.color}"> € {{ total_price }}</span>
        </div>
        <div class="total-price" v-else>
            {{ $t('general.total') }}: <span class="total-price__price" :style="{color: widget.style.color}">€ {{ total_price }}</span>
        </div>
        <div class="widget_buttons mobile-hide">
            <button
                v-if="blocked_btn"
                type="button"
                class="widget_btn btn_submit"
                :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                :style="{ background: '#777', color: '#fff' }">
                    <span class="spinner-icon">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 4335 4335"
                             width="100" height="100"><path fill="#ffffff"
                                                            d="M3346 1077c41,0 75,34 75,75 0,41 -34,75 -75,75 -41,0 -75,-34 -75,-75 0,-41 34,-75 75,-75zm-1198 -824c193,0 349,156 349,349 0,193 -156,349 -349,349 -193,0 -349,-156 -349,-349 0,-193 156,-349 349,-349zm-1116 546c151,0 274,123 274,274 0,151 -123,274 -274,274 -151,0 -274,-123 -274,-274 0,-151 123,-274 274,-274zm-500 1189c134,0 243,109 243,243 0,134 -109,243 -243,243 -134,0 -243,-109 -243,-243 0,-134 109,-243 243,-243zm500 1223c121,0 218,98 218,218 0,121 -98,218 -218,218 -121,0 -218,-98 -218,-218 0,-121 98,-218 218,-218zm1116 434c110,0 200,89 200,200 0,110 -89,200 -200,200 -110,0 -200,-89 -200,-200 0,-110 89,-200 200,-200zm1145 -434c81,0 147,66 147,147 0,81 -66,147 -147,147 -81,0 -147,-66 -147,-147 0,-81 66,-147 147,-147zm459 -1098c65,0 119,53 119,119 0,65 -53,119 -119,119 -65,0 -119,-53 -119,-119 0,-65 53,-119 119,-119z"
                        /></svg></span>
            </button>
            <button
                v-else
                type="submit"
                class="widget_btn"
                :form="form"
                :class="widget.style.roundedCorners ? '' : 'border-radius-0'"
                :style="{ background: widget.style.color, color: '#fff' }">
                <span>{{ $t('general.submit-order') }}</span>
            </button>
            <div class="order_status_message">{{ order_status_message }}</div>
        </div>
    </div>
</template>

<script>
import {lineTotal, lineVariationGroups, removeCartLine} from "@/widget/cartLines";

export default {
    props: ["widget", "order_created", "blocked_btn", "cart", "total_price", "total_price_calc", "btnPlusCart", "btnMinusCart", "setCartQty", "setCartVariation", "products", "deliveryCost", "order_status_message"],
    data: () => ({
        form: 'widget_form',
    }),
    computed: {
        variationEditable() {
            // per shop setting, off unless the shop switched it on
            const value = this.widget && this.widget.settings ? this.widget.settings.cart_variation_editable : null
            return !!value && value !== '0' && value !== 'false'
        },
    },
    methods: {
        variationGroups(item) {
            if (!this.variationEditable || !item.variation_name || !this.products) {
                return []
            }
            return lineVariationGroups(this.products.find(product => product.id === item.id_product), item)
        },
        itemPrice(item) {
            return lineTotal(item).toFixed(2)
        },
        onQtyInput(item, value) {
            // live update while typing; clearing the field or typing 0 is handled on change
            if (parseInt(value, 10) > 0) {
                this.setCartQty(item, value)
            }
        },
        onQtyChange(item, value) {
            if (String(value).trim() === '' || isNaN(parseInt(value, 10))) {
                // nothing usable typed: show the current quantity again
                let qty = item.qty_product
                item.qty_product = null
                this.$nextTick(() => item.qty_product = qty)
                return
            }
            // 0 removes this line, just like the minus button
            this.setCartQty(item, value)
        },
        remove_from_cart(item) {
            removeCartLine(this.cart, item.line_id)
            this.total_price_calc()
            this.$emit('remove-from-cart');
        },
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 910px) {
    .total-price {
        margin-bottom: 31px;
        margin-left: 0;
    }
    .product-cart .cart-title {
        padding-left: 0;
    }
    .order_details .product-cart .cart-title {
        padding-left: 0;
    }
}

@media only screen and (max-width: 700px) {
    .v-card__title {
        justify-content: center;
    }
    .card-product__data {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .card-item .card-product {
        flex-direction: row;
    }
}

.card-product__data {
    .order-block__price {
        text-align: start;
    }
}

.fz-12 {
    font-size: 12px;
}

.font-weight-light {
    font-weight: 100;
}

.text--black {
    color: black;
}

.btn-qty {
    min-width: 0 !important;
    width: 30px !important;
    padding: 0 !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.pl-0 {
    padding-left: 0;
}

.widget_title,
.cart-title,
.widget-row-form .title {
    font-family: 'Inter', sans-serif;
    font-weight: normal;
    font-size: 15px;
    color: black;
}

.wrap_select {
    font-size: 13px;
}

@media only screen and (max-width: 910px) {
    .order_details {
        .card-product {
            .card-product__data {
                align-items: flex-start;
                text-align: left;
                margin-left: 10px;
            }
        }
    }

    .order_details  {
        .product-cart {
            .card-item {
                .card-product__data {
                    .card-product__wrap-text {
                        .card-product__title {
                            text-align: left;
                            justify-content: flex-start;
                        }
                    }
                }
            }
        }
    }
}

.card-actions--variation {
    align-self: stretch;
    width: 100%;
    min-width: 0;
}

.order-block--variation {
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 6px 8px;
    min-width: 0;

    .qty-block {
        flex: 0 0 auto;
    }
}

.cart-variations {
    display: flex;
    gap: 4px;
    flex: 1 1 0;
    min-width: 48px;
    max-width: 130px;
}

.cart-variations__item {
    position: relative;
    display: flex;
    flex: 1 1 0;
    min-width: 0;
}

.cart-variations__select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: auto;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    margin-top: 0;
    padding: 0 18px 0 6px;
    font-size: 13px !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background: #FEFEFE;
    cursor: pointer;
}

.cart-variations__triangle {
    position: absolute;
    z-index: 13;
    top: 50%;
    right: 3px;
    width: 15px;
    height: 15px;
    transform: translateY(-50%);
    pointer-events: none;

    svg {
        display: block;
        fill: #8E939A;
    }
}

.cart-variations__price {
    flex: 0 0 auto;
    margin: 0 0 0 auto;
    align-self: center;
    white-space: nowrap;
}

.order_status_message {
    font-size: 14px;
}

/* phones: dropdown on its own row above - qty + (same height), the price on a row below */
@media only screen and (max-width: 599px) {
    .card-actions--variation {
        max-width: 100%;
    }

    .order-block--variation {
        display: grid;
        width: 100%;
        grid-template-columns: minmax(0, 1fr);
        grid-template-rows: 1fr 1fr auto;
        gap: 6px 0;

        .cart-variations {
            min-width: 0;
            max-width: none;
        }

        .qty-block {
            justify-self: start;
        }

        .cart-variations__price {
            margin: 0;
        }
    }
}
</style>
